import axios from "axios";
import { store } from "../store";

export interface AvailableCombination {
  CompanyCode: string; 
  SchemeCode: string;
  Year: string;
}

// const baseURL = process.env.REACT_APP_EMPLOYEE_PORTAL_API;


export interface RegisterMigrationRequest {
  CompanyCode: string;
  CompanyName: string;
  SchemeCode: string;
  SchemeName: string;
  Year: number;
  CreationUser: string;
}


export interface CancelMigrationRequest {
  Id: string;
  ModificationUser: string;
}

const Axios = axios.create({
    baseURL: "https://s10cloud.com:50023/CentralPrueba",
});

const getBasicHeaders = () => {
  const authCompanySelectedState = store.getState().auth.companyselected;
  return {
    'Token': authCompanySelectedState?.Token,
    'ModuleId': process.env.REACT_APP_MODULE_ID,
    'env': process.env.REACT_APP_ENV,
    'Content-Type': 'application/json',
  };
}

export const fetchAvailableCombinations = async (): Promise<AvailableCombination[]> => {
  const headers = await getBasicHeaders();
  const {data} = await Axios.get('/api/AccountingEntryProcessApi/GetDownloadedAccountingEntries', {headers})
    .catch(e => {
      console.error('error getting available combinations', e);
      return {data: []};
    });
  console.log('--- response.data', data);

  if (!data?.length) {
    return [];  
  }
  return data
};


export const dataGridData = async (params: Record<string, any>) => {
  Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
  const headers = await getBasicHeaders();
  const queryString = new URLSearchParams(params)// .toString();
  const url = `/api/AsientoContableApi/SearchAsientoContableQuery?${queryString}`;
  const {data} = await Axios.get(url, {headers})
    .catch(e => {
      console.error('error dataGridData', e);
      return {data: {}};
    });
  console.log(data)
  return { data: data.data || [], totalCount: data.totalCount || 0 };
}

export const registerMigrationProcess = async (data: RegisterMigrationRequest): Promise<any> => {
  const headers = await getBasicHeaders();
  const response = await Axios.post('/api/AccountingEntryProcessApi/RegisterAccountingEntryProcess', data, {headers})
  return response.data;
};

export const getMigrationResume = async (): Promise<any> => {
  const headers = await getBasicHeaders();
  const response = await Axios.get('/api/AccountingEntryProcessApi/GetAccountingEntryProcess', {headers})
    .catch(e => {
      console.error('error getMigrationResume', e);
      return {data: {}};
    });
  return response.data;
};

export const cancelMigrationProcess = async (data: CancelMigrationRequest): Promise<any> => {
  const headers = await getBasicHeaders();
  const response = await Axios.post('/api/AccountingEntryProcessApi/CancelAccountingEntryProcess', data, {headers})
    .catch(e => {
      console.error('error registerMigrationProcess', e);
      return {data: {}};
    });
  return response.data;
};

// export const dataGridDatav0 = async (params: Record<string, any>) => {
//     Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
//     const queryString = new URLSearchParams(params)// .toString();
//     const url = `https://s10cloud.com:50023/CentralPrueba/api/AsientoContableApi/SearchAsientoContableQuery?${queryString}`;
//     try {
//         const response = await fetch(url);
//         if (!response.ok) throw new Error(`HTTP ${response.status}`);
//         const result = await response.json();
//         return { data: result.data || [], totalCount: result.totalCount || 0 };
//     } catch (error) {
//         console.error('Error cargando datos:', error);
//         return { data: [], totalCount: 0 };
//     }
// }